module.exports = __webpack_public_path__ + "img/28965c8.jpg";